// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyCart_wrapper__E_1yQ","header":"EmptyCart_header___5vqn","text":"EmptyCart_text__L7kAe"};